module.exports = __webpack_public_path__ + "media/images/icon-operator-89e04ab5.svg";